(() => {
  function init(root) {
    if (root.dataset.urbensoryReady) return;
    root.dataset.urbensoryReady = 'true';
    const photos = [...root.querySelectorAll('[data-gallery-image]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const stage = root.querySelector('[data-stage]');
    const dialog = root.querySelector('[data-gallery-dialog]');
    const viewerImage = root.querySelector('[data-viewer-image]');
    let returnFocus, previousOverflow;
    let active = 0;
    function updateViewer() {
      if (!dialog?.open || !photos[active]) return;
      const photo = photos[active];
      viewerImage.src = photo.dataset.fullSrc || photo.currentSrc || photo.src;
      viewerImage.alt = photo.alt;
      root.querySelector('[data-viewer-count]').textContent = `${active + 1} / ${photos.length}`;
    }
    function openViewer() {
      if (!dialog || !photos.length || dialog.open) return;
      returnFocus = root.contains(document.activeElement) ? document.activeElement : stage;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      updateViewer();
    }
    function restorePage() {
      if (previousOverflow !== undefined) {
        document.documentElement.style.overflow = previousOverflow;
        previousOverflow = undefined;
      }
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    }
    if (dialog) {
      stage.dataset.fullscreenEnabled = 'true';
      root.querySelector('[data-gallery-open]')?.addEventListener('click', openViewer);
      root.querySelector('[data-viewer-close]').addEventListener('click', () => dialog.close());
      root.querySelector('[data-viewer-prev]').addEventListener('click', () => show(active - 1));
      root.querySelector('[data-viewer-next]').addEventListener('click', () => show(active + 1));
      dialog.addEventListener('close', restorePage);
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        if (dialog.open) { dialog.close(); restorePage(); }
      }, { once: true });
    }
    root.querySelectorAll('[data-gallery-prev], [data-gallery-next], [data-viewer-prev], [data-viewer-next]').forEach(button => { button.hidden = photos.length < 2; });
    function show(index) {
      if (!photos.length) return;
      active = (index + photos.length) % photos.length;
      photos.forEach((photo, i) => { photo.hidden = i !== active; });
      thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === active)); });
      root.querySelector('[data-gallery-count]').textContent = String(active + 1).padStart(2, '0') + ' / ' + String(photos.length).padStart(2, '0');
      updateViewer();
    }
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(active - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(active + 1));
    stage?.addEventListener('keydown', event => {
      if (event.target === stage && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); openViewer(); }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let suppressClickUntil = 0;
    stage?.addEventListener('click', event => {
      if (event.target.matches('[data-gallery-image]') && Date.now() > suppressClickUntil) openViewer();
    });
    function swipe(element) {
      let start;
      element?.addEventListener('touchstart', event => {
        start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      element?.addEventListener('touchend', event => {
        if (!start) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          suppressClickUntil = Date.now() + 450;
          show(active + (dx < 0 ? 1 : -1));
        }
        start = null;
      }, { passive: true });
      element?.addEventListener('touchcancel', () => { start = null; }, { passive: true });
    }
    swipe(stage);
    swipe(root.querySelector('[data-viewer-stage]'));
    const select = root.querySelector('[data-variant-select]');
    function variantChanged() {
      if (!select) return;
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      root.querySelector('[data-price]').textContent = option.dataset.price;
      const button = root.querySelector('[data-buy]');
      button.disabled = !available;
      button.textContent = available ? `${select.dataset.buyLabel} ↗` : select.dataset.soldOutLabel;
      root.querySelector('[data-availability]').textContent = available ? '' : select.dataset.unavailableLabel;
      const mediaIndex = photos.findIndex(photo => photo.dataset.mediaId && photo.dataset.mediaId === option.dataset.mediaId);
      if (mediaIndex >= 0) show(mediaIndex);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    }
    select?.addEventListener('change', variantChanged);
    show(0);
    if (select?.selectedOptions[0]?.dataset.mediaId) {
      const i = photos.findIndex(photo => photo.dataset.mediaId === select.selectedOptions[0].dataset.mediaId);
      if (i >= 0) show(i);
    }
  }
  function initAll() { document.querySelectorAll('[data-urbensory-wallet]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
